/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:phoneValidator
 * @restrict A
 * @param    {string=} phoneValidator   Error popup title.
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} disableValidator "true"=skip validation.
 * @param    {string=} minValue         Minimum value.
 * @param    {string=} maxValue         Maximum value.
 *
 * @description
 * Validator to verify a text input value is a phone number.
 **/
/* @ngInject */
export function phoneValidator(CSMValidatorService, Tools) {
  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      var error = CSMValidatorService.BaseValidator.prototype.doValidate.call(
        this,
        value
      );
      return (
        error ||
        (value && !Tools.parsePhone(value) ? 'Invalid phone number' : null)
      );
    }
  });
}
